module.exports = __webpack_public_path__ + "static/media/inplay-mob.1dcb6044.svg";